import { isError } from 'lodash'
import { addSharingGroupMembers, createSharingGroup, deleteSharingGroup, editSharingGroup, getSharingGroup, getSharingGroupsByOwner, removeSharingGroupMembers } from '../../services/SharingGroupService'

export default {
  state: {
    sharingGroup: {
      name: '',
      userSharingGroups: []
    },
    mySharingGroups: []
  },

  mutations: {
    clearSharingGroup(state) {
      state.sharingGroup = {
        name: '',
        userSharingGroups: []
      }
    },
    editSharingGroupField(state, { field, value }) {
      state.sharingGroup[field] = value
    },
    addSharingGroupMember(state, userId) {
      state.sharingGroup.userSharingGroups = [...state.sharingGroup.userSharingGroups, { userId }]
    },
    removeSharingGroupMember(state, userId) {
      state.sharingGroup.userSharingGroups = state.sharingGroup.userSharingGroups.filter(user => user.userId !== userId)
    },
    hydrateSharingGroup(state, group) {
      state.sharingGroup = group
    },
    hydrateMySharingGroups(state, data) {
      state.mySharingGroups = data
    }
  },

  actions: {
    clearSharingGroup({ commit }) {
      commit('clearSharingGroup')
    },
    editSharingGroupField({ commit }, { field, value }) {
      commit('editSharingGroupField', { field, value })
    },
    addSharingGroupMember({ commit }, userId) {
      commit('addSharingGroupMember', userId)
    },
    removeSharingGroupMember({ commit }, userId) {
      commit('removeSharingGroupMember', userId)
    },
    async createSharingGroup({ commit, state }) {
      const response = await createSharingGroup({
        name: state.sharingGroup.name,
        userSharingGroups: state.sharingGroup.userSharingGroups
      }).catch(e => e.response)
      const success = !isError(response.status)
      return { success, error: response.data }
    },
    async hydrateSharingGroup({ commit }, groupId) {
      const response = await getSharingGroup(groupId).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateSharingGroup', response.data)
      return { success, error: response.data }
    },
    async hydrateMySharingGroups({ commit, rootState }) {
      const response = await getSharingGroupsByOwner(rootState.userInfo.userInfo.userId).catch(e => e.response)
      const success = !isError(response.status)
      if (success) commit('hydrateMySharingGroups', response.data)
      return { success, error: response.data }
    },
    async addCreatedSharingGroupMembers({ commit }, { groupId, members }) {
      const response = await addSharingGroupMembers({ groupId, members }).catch(e => e.response)
      const success = !isError(response.status)
      return { success, error: response.data }
    },
    async removeCreatedSharingGroupMembers({ commit }, { groupId, members }) {
      const response = await removeSharingGroupMembers({ groupId, members }).catch(e => e.response)
      const success = !isError(response.status)
      return { success, error: response.data }
    },
    async editSharingGroup({ commit, state }) {
      const response = await editSharingGroup({ groupId: state.sharingGroup.id, sharinGroup: state.sharingGroup }).catch(e => e.response)
      const success = !isError(response.status)
      return { success, error: response.data }
    },
    async deleteSharingGroup({ commit }, { groupId }) {
      const response = await deleteSharingGroup(groupId).catch(e => e.response)
      const success = !isError(response.status)
      return { success, error: response.data }
    }
  }
}
